import { useRef } from 'react';
const defaultValue = Symbol();
export function useInitial(initialValue) {
  const ref = useRef(defaultValue);
  if (ref.current === defaultValue) {
    ref.current = initialValue();
  }
  return ref.current;
}